import { Component, Input, OnInit } from '@angular/core';
import { CertificationRequestStatus } from 'src/app/model/enums/certification-requests-status';

@Component({
    selector: 'status-display',
    templateUrl: './status-display.component.html',
    styleUrls: ['./status-display.component.css'],
    standalone: false
})
export class StatusDisplayComponent implements OnInit {
    public color = 'rgba(var(--app-on-surface-rgb), 0.67)';

    @Input()
    status: CertificationRequestStatus;

    constructor() { }

    ngOnInit() { }

    ngOnChanges() {
        this.setColor(this.status);
    }

    setColor(status: string) {
        switch (this.status) {
            case CertificationRequestStatus.REQUESTED: {
                this.color = 'rgba(var(--app-on-surface-rgb), 0.67)';
                break;
            }
            case CertificationRequestStatus.ACCEPTED: {
                this.color = 'var(--app-accent)';
                break;
            }
            case CertificationRequestStatus.WAITING: {
                this.color = 'rgba(var(--app-on-surface-rgb), 0.67)';
                break;
            }
            case CertificationRequestStatus.IN_PROGRESS: {
                this.color = 'var(--app-accent)';
                break;
            }
            case CertificationRequestStatus.PASSED: {
                this.color = 'var(--app-primary)';
                break;
            }
            case CertificationRequestStatus.NOT_PASSED: {
                this.color = 'var(--app-warn)';
                break;
            }
            case CertificationRequestStatus.CLOSED: {
                this.color = 'var(--app-primary)';
                break;
            }
            default:
                this.color = 'var(--app-warn)';
        }
    }
}
